import Vue from "vue";
import VueCompositionAPI from "@vue/composition-api";
import vSelect from "vue-select";
import moment from "moment";
import vClickOutside from "v-click-outside";
import VueMeta from "vue-meta";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "@/lang/i18n";

Vue.config.productionTip = false;

import VueMask from "v-mask";
import {
  LOGIN_USER,
  SET_USER_PHONE,
  SET_WSS_CONNECTION,
} from "@/store/action-types";
import { CentrifugoApi } from "@/office/centrifuge/centrifugo-api";
import { Centrifuge } from "centrifuge";

Vue.use(VueMeta);
Vue.use(VueMask, {
  placeholders: {
    Q: /[\w]/,
    T: /[\w0-9а-яА-ЯіІїЇєЄ]/,
  },
});
Vue.use(VueCompositionAPI);
Vue.use(vClickOutside);
Vue.component("v-select", vSelect);

Vue.prototype.$moment = moment;

const accessToken = localStorage.getItem("accessToken");
const phone = localStorage.getItem("phone");

function getToken() {
  return new Promise((resolve, reject) => {
    CentrifugoApi.getAccessToken()
      .then((r) => {
        resolve(r.data.token);
      })
      .catch((err) => reject(err));
  });
}

async function initWssConnection() {
  let tokenResponse = await CentrifugoApi.getAccessToken();

  let wss = new Centrifuge(process.env.VUE_APP_WSS_URL, {
    token: tokenResponse.data.token,
    getToken: function () {
      return getToken();
    },
  });

  wss.on("connected", () => {
    console.log("connected to wss:// server");
  });

  wss.connect();
  await store.dispatch(SET_WSS_CONNECTION, wss);
}

async function createApp() {
  await initWssConnection();

  if (accessToken) {
    await store.dispatch(LOGIN_USER, { accessToken, phone });
  } else if (phone) {
    await store.dispatch(SET_USER_PHONE, phone);
  }

  new Vue({
    router,
    i18n,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

createApp();
